/**
 * Created by anthony on 7/8/14.
 */
var schoolContactsModel = angular.module('schoolContactsModel', ['schoolModel']);
schoolContactsModel.factory('SchoolContactsModelFactory', function(ApplicationService, BaseModel, RestService, authServiceFactory, SchoolModelFactory){
    var SchoolContactsModel = function(){
        this.endpoint = '/Contact';
        this.primaryKey = 'recordID';
    }
    SchoolContactsModel.prototype = new SchoolModelFactory();
    SchoolContactsModel.prototype.parent = SchoolModelFactory.prototype;
    SchoolContactsModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }

    SchoolContactsModel.prototype.revertCopy = function()
    {
        this.data = angular.copy(this.get());
    }

    SchoolContactsModel.prototype.new = function()
    {
        var schoolID = this.arg;
        return this.data.push (
            {
                schoolID: schoolID, contactAddy1: '', contactAddy2: '', contactCity: '', contactEmail: '', contactNameFirst: '',
                contactNameLast: '', contactPrefix: '', contactState: '', contactTitle: '', contactZip: '', contact_Cell_Phone: '',
                contact_Cell_Phone_OK: '', contact_Work_Phone: '', contact_Work_Phone_Ext: '', email_all: '', email_daily: '',
                email_market: '', email_tax_all: '', email_tax_daily: '', email_tax_verification: '', email_updates: '', optedOut: '',
                optedOutReason: '', order: '', applicationNotifications: 0, taxNotifications: 0, primary: 1, deleted: 0, readOnly: 0, taxTab: 1, faculty: 1,
                requestCorrection: 1, confidential: 0
            }
        ) - 1;

    }
    return SchoolContactsModel;

});


schoolContactsModel.service('SchoolContactsModelService', function(SchoolContactsModelFactory){
    var schoolModel = new SchoolContactsModelFactory();
    return schoolModel;
});


